import { protectedRoute } from "@/utils/routeUtils";

const moduleTitle = "module_title.expatriate_document";
const allowedRoles = ["isVisaUser"];

const expatriateDocumentRoutes = {
  path: "expatriate-document",
  title: moduleTitle,
  sidebarProps: {
    key: "1-14",
    iconSrc: "expatriate-doc",
    label: moduleTitle,
    link: "/expatriate-document",
    groupingType: "TOOLS",
    order: 14,
    permissions: allowedRoles,
  },
  element: null,
  children: [
    {
      index: true,
      path: "",
      title: moduleTitle,
      element: protectedRoute(
        [() => import("@/pages/expatriate-document/ExpatriateDocList")],
        allowedRoles
      ),
    },
    {
      path: ":id",
      title: moduleTitle,
      headerProps: {
        backUrl: "/expatriate-document",
      },
      element: protectedRoute(
        [() => import("@/pages/expatriate-document/ExpatriateDocDetails")],
        allowedRoles
      ),
    },
  ],
};

export default expatriateDocumentRoutes;
